import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../../constants/path';
import { HeadComponent } from '../../../HeadComponent';
import InterestsFormComponent from './InterestsFormComponent';
import LocalizedBreadcrumbItem from '../../../breadcrumb/LocalizedBreadcrumbsItem';

export class InterestsPage extends React.Component {
    render() {
        const { i18nPage } = this.props;
        return (
            <main id="p-myinterests">
                <HeadComponent title={i18nPage.TITLE} description={i18nPage.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.ACCOUNT_CENTER_PATH}>
                    {i18nPage.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <InterestsFormComponent />
            </main>
        );
    }
}

export default connect(state => ({ i18nPage: state.i18n.page.ACCOUNT.INTERESTS }))(InterestsPage);



// WEBPACK FOOTER //
// ./src/components/pages/account/myinterests/InterestsPage.js